import { useProductStatus } from './useProductStatus.hook';
import { InsurancePackageState, InsuranceServiceName } from '@/@types/insurance';
import { ProductsStatusKey } from '@/@types/productsStatus';

export const useInsurancePackageStatus = () => {
  const insurancePackage = useProductStatus(ProductsStatusKey.insurancePackage) as InsurancePackageState;

  const isServiceActive = (serviceName: InsuranceServiceName) => {
    if (!['ACTIVATED', 'PENDING'].includes(insurancePackage?.status)) return false;
    return insurancePackage?.services.includes(serviceName);
  };
  return {
    isRechtsberatungEntitled: isServiceActive(InsuranceServiceName.RECHTSBERATUNG),
    isMietrechtsschutzEntitled: isServiceActive(InsuranceServiceName.MIETRECHTSSCHUTZ),
    isMediationEntitled: isServiceActive(InsuranceServiceName.MEDIATION),
    isSchluesseldienstEntitled: isServiceActive(InsuranceServiceName.SCHLUESSELDIENST),
    insurancePackageStatus: insurancePackage?.status,
    insurancePackageType: insurancePackage?.type,
  };
};

export const useIsServiceActive = (serviceName: InsuranceServiceName) => {
  const insurancePackage = useProductStatus(ProductsStatusKey.insurancePackage) as InsurancePackageState;
  const isServiceActive = (serviceName: InsuranceServiceName) => {
    if (!['ACTIVATED', 'PENDING'].includes(insurancePackage?.status)) return false;
    return insurancePackage?.services.includes(serviceName);
  };
  return isServiceActive(serviceName);
};
